<template>
    <div class="buttons are-small mb-4">
        <template v-if="store.bulkSelectionEnabled">
            <button
                class="button"
                :title="translate(store.allVisibleSelected ? 'common.deselect_all' : 'common.select_all')"
                :aria-label="translate(store.allVisibleSelected ? 'common.deselect_all' : 'common.select_all')"
                @click="store.toggleVisibleSelection(!store.allVisibleSelected)"
            >
                <span class="icon">
                    <i class="fa fa-check-square" v-if="store.allVisibleSelected" />
                    <i class="fa fa-square" v-else />
                </span>
            </button>

            <button class="button" @click="store.clearSelection()">
                <span class="icon">
                    <i class="fa fa-times" />
                </span>
                <span>{{ translate("common.cancel") }}</span>
            </button>

            <button class="button is-danger" :disabled="store.totalSelectedCount === 0" @click="emit('deleteSelected')">
                <span class="icon">
                    <i class="fa fa-trash"></i>
                </span>
                <span>
                    {{ translate("common.delete_selected") }}
                </span>
            </button>

            <span class="is-description ml-2">
                {{ translate("common.selected_count", false, [store.totalSelectedCount]) }}
            </span>
        </template>
        <button v-else class="button" @click="store.enableBulkSelection()">
            <span class="icon">
                <i class="fa fa-tasks" />
            </span>
            <span>{{ translate("admin_payment.select_many") }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../../Common/translations";
    import { useBracketsListingStore } from "./bracketsListingApp";

    const emit = defineEmits<{
        deleteSelected: [];
    }>();

    const store = useBracketsListingStore();
</script>

<style scoped></style>
